import { render, staticRenderFns } from "./SingleDepartmentIndexView.vue?vue&type=template&id=7cb9f0ad"
import script from "./SingleDepartmentIndexView.vue?vue&type=script&lang=js"
export * from "./SingleDepartmentIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports